import { render, staticRenderFns } from "./FilterSidebarSizesGroup.vue?vue&type=template&id=10afdd6a&scoped=true&"
import script from "./FilterSidebarSizesGroup.vue?vue&type=script&lang=js&"
export * from "./FilterSidebarSizesGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10afdd6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10afdd6a')) {
      api.createRecord('10afdd6a', component.options)
    } else {
      api.reload('10afdd6a', component.options)
    }
    module.hot.accept("./FilterSidebarSizesGroup.vue?vue&type=template&id=10afdd6a&scoped=true&", function () {
      api.rerender('10afdd6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/FilterSidebarSizesGroup.vue"
export default component.exports